@if (order) {
  <div class="order-medicine-item-list__toolbar">
    <button type="button" mat-stroked-button class="order-medicine-item-list__btn" (click)="printAllLabels()">
      <mat-icon>print</mat-icon> Print all labels
    </button>
  </div>
}

<div class="order-medicine-item-list__table-scroll">
  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="dataSource" class="mbp-data-table order-medicine-item-list__table">
      <ng-container matColumnDef="medicine">
        <th mat-header-cell *matHeaderCellDef class="name-col">Medicine</th>
        <td mat-cell *matCellDef="let item" class="name-col">{{ item.medicine?.name || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="dosage">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let item">
          {{ item.medicineDosagePackageType.medicine_dosage_type.additional_information }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pack_size">
        <th mat-header-cell *matHeaderCellDef>Pack size</th>
        <td mat-cell *matCellDef="let item">{{ item.medicineDosagePackageType.contained_quantity }}</td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let item">
          {{ item.medicineDosagePackageType.price | currency:'ZAR':'symbol-narrow' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef class="actions-col">&nbsp;</th>
        <td mat-cell *matCellDef="let item" class="actions-col">
          <div class="order-medicine-item-list__actions">
            <button
              type="button"
              class="order-medicine-item-list__btn order-medicine-item-list__btn--warn"
              (click)="deleteOrderItem(item)"
              mat-stroked-button
            >
              <mat-icon>delete_outline</mat-icon> Remove
            </button>

            @if (order) {
              <button type="button" class="order-medicine-item-list__btn" mat-stroked-button (click)="printLabels([item])">
                <mat-icon>print</mat-icon> Print labels
              </button>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
